<template>
  <div>
    <div class="mb-3">
      <icon-view
        :has-border="false"
        icon="fas fa-times-circle text-orange"
        icon-size="17px"
        title="Razón de Cancelación de Transferencia"
        variant="custom-icon-view"
        icon-background="white"
      />
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario de Justificación:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";

export default {
  name: "CancelTransfer",
  components: {
    IconView,
    CustomTextArea,
    ActionButton
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      model: {
        comment: ""
      }
    };
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea cancelar la solicitud?`,
        "Sí",
        "No"
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        bookId: this.item.id,
        comment: this.model.comment
      };

      const { data } = await inventoryOrderBooksService.cancelTransfer(payload);
      if (data) {
        this.ShowToast(
          "Éxito",
          "La solicitud ha sido cancelada exitosamente.",
          "success"
        );
        this.$emit("close");
        this.$emit("refresh");
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
